import React from "react";
import { Button } from "react-bootstrap";
import Navbar from "../../Components/Navbar";
import { useNavigate } from "react-router-dom";
import CalendarSc from "./index.sc";
const calendarDetails = [
  {
    nameOfHoliday: "New Year's day",
    date: "02-jan-23",
  },
];
function Index() {
  const navigate = useNavigate();
  return (
    <div>
      <CalendarSc></CalendarSc>
    </div>
  );
}

export default Index;
